import { render } from "./QuizCard.vue?vue&type=template&id=0d56d494&scoped=true"
import script from "./QuizCard.vue?vue&type=script&lang=js"
export * from "./QuizCard.vue?vue&type=script&lang=js"

import "./QuizCard.vue?vue&type=style&index=0&id=0d56d494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d56d494"]])

export default __exports__